export default __webpack_public_path__ + "static/media/globeWhite.fff188a8.svg";